// Core
import React, { useState } from "react";

// Components - Contrib
import { Card, Button } from "react-bootstrap";

// Components - Custom
import "./App.css";
import { questions, answers } from "./data/multiPolicy";
import Question from "./components/question";
import Answer from "./components/answer";

function App() {
   // Saving Selection History of the DMTd
   const [dmt_history, setDmt_history] = useState(["q-1"]);
   const qa = dmt_history[dmt_history.length - 1].charAt(0);

   // Saving initial panel into state to keep track of steps
   const [target, setTarget] = useState("");

   // Current Data Object
   const data = qa === "q" ? questions.find((q) => q.id === dmt_history[dmt_history.length - 1]) : answers.find((a) => a.id === dmt_history[dmt_history.length - 1]);

   const handleGoBack = () => {
      const newHistory = [...dmt_history];
      newHistory.pop();
      setDmt_history(newHistory);
   };

   const handleGoNext = () => {
      setDmt_history((dmt_history) => [...dmt_history, target]);
      setTarget("");
   };

   const handleStartOver = () => {
      setDmt_history(["q-1"]);
   };

   return (
      <Card className="shadow-sm">
         <Card.Header className="bg-third bg-opacity-10 px-5 py-0">
            <h3 className="my-4">{qa === "q" ? `Question` : "Result"}</h3>
         </Card.Header>
         <Card.Body className="p-5 py-4 my-3">{qa === "q" ? <Question qOjb={data} currentTarget={target} newTarget={setTarget} /> : <Answer aObj={data} newTarget={setTarget} />}</Card.Body>
         <Card.Footer className="d-flex bg-third bg-opacity-10 py-4 px-5">
            <Button variant="primary" onClick={handleGoBack} disabled={dmt_history.length === 1 ? true : false}>
               Back
            </Button>
            <Button variant="primary" onClick={handleGoNext} className="ms-auto" disabled={target === "" ? true : false}>
               Next
            </Button>
            <Button variant="primary" onClick={handleStartOver} className={qa === "q" ? "d-none" : "ms-2"}>
               Start Over
            </Button>
         </Card.Footer>
      </Card>
   );
}

export default App;
